// extracted by mini-css-extract-plugin
export default {"period":"PeriodBlock_period__qgSji"};